import { ResourcesConfig } from 'aws-amplify';

/**
 * AWS Amplify configuration
 * Environment variables are injected by Vite at build time
 * These are configured in the FrontendStack CDK construct
 */
export const amplifyConfig: ResourcesConfig = {
  API: {
    GraphQL: {
      endpoint: import.meta.env.VITE_APPSYNC_ENDPOINT || '',
      region: import.meta.env.VITE_AWS_REGION || 'us-west-2',
      defaultAuthMode: 'userPool',
      apiKey: import.meta.env.VITE_APPSYNC_API_KEY || '',
    },
  },
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_USER_POOL_ID || '',
      userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID || '',
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_OAUTH_DOMAIN || '',
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: [import.meta.env.VITE_OAUTH_REDIRECT_SIGNIN || 'http://localhost:5173/signin'],
          redirectSignOut: [import.meta.env.VITE_OAUTH_REDIRECT_SIGNOUT || 'http://localhost:5173/'],
          responseType: 'code',
          // Amplify v6 requires the provider list to be declared in the
          // config when `signInWithRedirect({ provider: { custom } })`
          // is used against a Cognito pool. Without this, Amplify raises
          // "oauth param not configured" on click because it can't
          // resolve the custom provider name against the config.
          providers: ['Google', 'Apple'],
        },
      },
    },
  },
};

/**
 * Environment configuration
 */
export const environment = {
  stage: import.meta.env.VITE_STAGE || 'dev',
  region: import.meta.env.VITE_AWS_REGION || 'us-west-2',
};
